import { Drawer, Button, Input, Tabs } from 'mk-pc'
import { FunctionList } from './FunctionList'
import { DataScopeList } from './DataScopeList'
import './index.scss'

interface Props {
  current?: any
  visible: boolean
  onClose?: () => void
}

/**
 * 导航功能点/权限点
 */
export const NavFunction = ({ visible, current, onClose }: Props) => {
  return (
    <Drawer title="导航权限点维护" width={860} size="small" className="navp" open={visible} onClose={onClose} closeIcon={false}>
      <div className="navp-content">
        <div className="navp-text">
          <p className="navp-text__item">
            <label>导航编码</label>
            <Input value={current?.code} readonly />
          </p>
          <p className="navp-text__item">
            <label>导航名称</label>
            <Input value={current?.name} readonly />
          </p>
        </div>
        <div className="navp-tabs">
          <Tabs
            defaultActiveKey="1"
            items={[
              {
                key: 'functions',
                label: '操作权限',
                children: <FunctionList value={current} />
              },
              {
                key: 'dataPermissions',
                label: '数据权限',
                children: <DataScopeList value={current} />
              }
            ]}
          />
        </div>
      </div>
      <footer className="navp-footer">
        <Button onClick={() => onClose && onClose()}>返回</Button>
      </footer>
    </Drawer>
  )
}
